import { render } from "./TriggerSettingSelector.vue?vue&type=template&id=32ddbe9a&scoped=true"
import script from "./TriggerSettingSelector.vue?vue&type=script&lang=ts"
export * from "./TriggerSettingSelector.vue?vue&type=script&lang=ts"

import "./TriggerSettingSelector.vue?vue&type=style&index=0&id=32ddbe9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-32ddbe9a"

export default script
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QInput,QField});
